export class JournalAPIModel {
  JournalAPI: string = "";
  JournalDetailsAPI: string = "";
  SaveJournalInfo: string = "";
  GetOptions: string = "";
  CheckDuplicate: string = "";
  JournalDeliveryMethodList: string = "";
  JournalUploadKeyFile: string = "";
  JournalDownloadKeyFile: string = "";
  JournalTypeAPI: string = "";
  PublisherIDAPI: string = "";
  ArticleTypeListAPI: string = "";
  JournalOnshoreUpdate: string = "";
  DeleteJournalOnshoreByID: string = "";
  SuccessMsg: string = "";
  FailedMsg: string = "";
  JournalTitleErrorMsg: string = "";
  PublisherErrorMsg: string = "";
  AcronymErrorMsg: string = "";
  DoiJournalCodeErrorMsg: string = "";
  JournalPublisherErrorMsg: string = "";
  ContactErrorMsg: string = "";
  AddressErrorMsg: string = "";
  EmailErrorMsg: string = "";
  EmailFormatErrorMsg: string = "";
  DuplicateJournalTitleErrorMsg: string = "";
  FieldConfigList: any;
  ProofingTypeAPI: any;
  JournalNotesByIDAPI: string;
  ShowJournalNotesByID: string;
  JournalNotesDownloadFilesAPI: string;
  DeleteJournalNotesByID: string;
  StagesListAPI: string = "";
  AlloctaedUsersAPI: string = "";
  ImportExcelfileAPI: any;
  ValidateImportExcelFile: any;
  DownloadBudgetsamplefileAPI: any;
  ShowOnshoreSettingByID: string;

}
